/* Tactical X PDP videos — no automatic audio and no hidden autoplay for source videos. */
(() => {
  function mount() {
    const films = document.querySelectorAll('[data-tx15-film]:not([data-tx15-ready])');
    if (!films.length) return;
    const prefersReduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    const observer = !prefersReduced && 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => entries.forEach(({target, isIntersecting}) => {
          const video = target.querySelector('video');
          if (!video) return;
          if (!isIntersecting && !video.paused) video.pause();
          if (isIntersecting && target.dataset.visibilityAutoplay === 'true' && video.paused) {
            video.muted = true;
            video.loop = true;
            video.play().then(() => target.classList.add('is-playing')).catch(() => {});
          }
        }), {threshold: 0.55}) : null;
    films.forEach((frame) => {
      frame.dataset.tx15Ready = 'true';
      const video = frame.querySelector('video');
      const play = frame.querySelector('[data-tx15-play]');
      if (!video) return;
      play?.addEventListener('click', async () => {
        video.muted = false;
        video.controls = true;
        video.loop = false;
        try { await video.play(); frame.classList.add('is-playing'); }
        catch (_) { video.controls = true; }
      });
      video.addEventListener('ended', () => {
        if (frame.dataset.visibilityAutoplay !== 'true') frame.classList.remove('is-playing');
      });
      if (frame.dataset.visibilityAutoplay === 'true') observer?.observe(frame);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();
